"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../lib/utils";
function Skeleton({ className, ...props }) {
    return (_jsx("div", { className: cn("stack-scope animate-pulse rounded-md bg-primary/10", className), ...props }));
}
export { Skeleton };
